import script from "./BoilerItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BoilerItemModal.vue?vue&type=script&setup=true&lang=js"

import "./BoilerItemModal.vue?vue&type=style&index=0&id=956cd784&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-956cd784"]])

export default __exports__